import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ChatRoomsPage from './pages/ChatRoomsPage';
import ChatRoomPage from './pages/ChatRoomPage';
import CategoryPage from './pages/CategoryPage';
import ProfilePage from './pages/ProfilePage';

function App() {
  const checkAuth = useAuthStore((state) => state.checkAuth);

  useEffect(() => {
    // Check authentication on app load
    checkAuth();
  }, [checkAuth]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/" element={<ChatRoomsPage />} />
      <Route path="/category/:category" element={<CategoryPage />} />
      <Route path="/room/:id" element={<ChatRoomPage />} />
      <Route path="/profile" element={<ProfilePage />} />
    </Routes>
  );
}

export default App;

